export enum AviosPartner {
  BAEC = 'British Airways Club',
}

export enum LinkingStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface LinkedAccount {
  partnerCode: string;
  partnerName: string;
  linkingStatus: LinkingStatus;
  linkedAt?: string;
}

export interface LinkedAccountsResponse {
  linkedAccounts?: LinkedAccount[];
}
